import { lastValueFrom, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { inject, Injectable } from '@angular/core';
import { ApiService } from '@core/services';
import { Campus } from '@shared/models';
import { ApiResponse } from '@shared/models/api.model';

@Injectable({
  providedIn: 'root',
})
export class CampusService {
  #apiService: ApiService = inject(ApiService);

  getCampus(): Observable<Campus[]> {
    return this.#apiService.get<ApiResponse<Campus[]>>('campus').pipe(
      map((res) => res.data),
      catchError(() => of([]))
    );
  }

  async getCampusData(): Promise<Campus[]> {
    try {
      const response = await lastValueFrom(this.#apiService.get<ApiResponse<Campus[]>>('campus'));
      return response?.data || [];
    } catch (error) {
      console.error('Error fetching campus data:', error);
      return [];
    }
  }
}
